import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalStateService {
  public handleMenu = signal(false);

  toogleMenu() {
    this.handleMenu.set(!this.handleMenu());
  }
}
